module.exports = {"title":"Novos lugares disponíveis","subtitle":"A Veloe acaba de fechar uma parceria com os Postos Shell. Mais uma comodidade .","seeMore":"Saiba mais"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/newPlaces/data.json
// module id = 2237
// module chunks = 0